var React = require('react');

function Template (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M9.5 0H4.587L0 4.95V13a1.5 1.5 0 0 0 1.5 1.5h8A1.5 1.5 0 0 0 11 13V1.5A1.5 1.5 0 0 0 9.5 0z","fill":"#C8C7C3","key":0}),React.createElement("path",{"d":"M11.009 13.835a.667.667 0 0 1-.667.666H6.417l4.592-4.97v4.304z","fill":"#929088","key":1})]));
}

Template.defaultProps = {"width":"12","height":"15","viewBox":"0 0 12 15"};

module.exports = Template;

Template.default = Template;
